import "./Header.css";
import JPMorganPayments from "../../../images/JPMorganPayments.svg";
import PaymentNet from "../../../images/PaymentNet.svg";
import {FlexItem, FlexLayout, Link} from "@salt-ds/core";

function Header() {

  return (
      <header>
          <FlexLayout className="pnet-header">
              <FlexItem>
                  <FlexLayout className="pnet-header-content">
                      <FlexItem className="pnet-header-logo">
                          <Link href="/auth/public/app">
                              <img src={JPMorganPayments} alt="J.P. Morgan Payments Icon" className="pnet-header-logo-img"                                   />
                          </Link>

                      </FlexItem>
                      <FlexItem className="pnet-header-heading">
                          <Link href={"#"}>
                              <img className="pnet-header-logo-img paymentnet-centre-logo"
                                src={PaymentNet} alt="PaymentNet Log In Image, Link"/>
                          </Link>
                      </FlexItem>
                      <FlexItem className="right-corner">
                          <Link href={"#"} className="pnet-logo">
                              <img className="pnet-header-logo-img"
                                src={PaymentNet} alt="PaymentNet Log In Image, Link"/>
                          </Link>
                      </FlexItem>
                  </FlexLayout>
              </FlexItem>

          </FlexLayout>
      </header>
  );
}


export default Header;